module.exports = __webpack_public_path__ + "static/media/logo.d0b8fb27.png";